// extracted by mini-css-extract-plugin
export default {"CategoryTabWrapper":"CategoryTabWrapper_CategoryTabWrapper__mpUVh"};